<template>
    <div>
        <SuperAdminSchoolHead class="sash-main sas-head">
            <template v-slot:title><span class="sas-title" v-html="$t('trainingMaterial')"/></template>
        </SuperAdminSchoolHead>
        <div class="scl-ad">
            <v-btn-toggle v-model="toggle_exclusive" tile group style="color: #2F80ED">
                <v-btn dense outlined v-for="item in childrenData" :key="item.id"
                       style="padding: 30px 10px; border-radius: 8px; color: black" @click="getScheduleByChildren(item)">
                    <div style="display: flex; flex-direction: column">
                        <div>{{item.studentName}} {{item.studentSurname}}</div>
                    </div>
                </v-btn>
            </v-btn-toggle>
            <v-pagination v-if="materials.length" v-model="currentPage"  :length="totalPages" :total-visible="10"></v-pagination>
            <v-simple-table v-if="materials.length" style="margin: 12px auto; width: max-content; min-width: 70%">
                <template v-slot:default>
                    <thead>
                    <tr>
                        <th class="text-table" v-html="$t('class')"/>
                        <th class="text-table" v-html="$t('course')"/>
                        <th class="text-table" v-html="`Описание`"/>
                        <th class="text-table" v-html="`Автор`"/>
                        <th class="text-table" v-html="`Ссылка на книгу`"/>
                        <th class="text-table"/>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="material in materials" :key="material.id">
                        <td v-html="material.classLevel"/>
                        <td v-html="material.courseTitle"/>
                        <td v-html="material.description"/>
                        <td v-html="material.author"/>
                        <td><a :href="material.url" v-html="`Перейти`" target="_blank"/></td>
                        <td>
                            <v-btn :disabled="!material['attachmentUrl']" variant="outlined" size="large"
                                   icon color="primary" @click="downloadFile(material['attachmentUrl'])">
                                <v-icon color="primary">mdi mdi-download-outline</v-icon>
                            </v-btn>
                        </td>
                    </tr>
                    </tbody>
                </template>
            </v-simple-table>
        </div>
    </div>
</template>

<script>
import StudyMaterialService from '@/_services/study-material.service'
import { CourseService } from '@/_services/course.service'
import ParentService from '@/_services/parent.service'
import SuperAdminSchoolHead from "@/components/super-admin/schools/SuperAdminSchoolHead.vue";
const courseService = new CourseService()

export default {
  name: 'StudyMaterial',
    components: {SuperAdminSchoolHead},
  data () {
    return {
      materials: [],
        toggle_exclusive: null,
        childrenData: [],
      currentPage: 1,
      totalPages: 0
    }
  },
  computed: {
    userProfile () {
      return this.$store.state.account.profile
    },
    school () {
      return this.userProfile.schools[0]
    }
  },
  created () {
      this.getChildren()
  },
  watch: {
    async currentPage (val) {
      if (val === 0) this.getAllMaterials(val)
      else this.getAllMaterials(val - 1)
    }
  },
  methods: {
      getScheduleByChildren (item) {
          this.getAllMaterials(0, item.schoolId)
          this.getSchoolCourseList(item.schoolId)
      },
      getChildren () {
          ParentService.getAllChildren(this.userProfile.personId).then((res) => {
              this.isLoading = false
              if (res._embedded) {
                  this.childrenData = res._embedded.studentParentResourceList
              } else {
                  this.childrenData = []
              }
          }).catch((err) => {
              this.$toast.error(err)
              this.isLoading = false
          })
      },
    getAllMaterials (page, schoolId) {
      StudyMaterialService.fetchList(schoolId, page, 10).then((res) => {
        this.materials = res.content
        this.totalPages = res.totalPages
      }).catch((err) => {
        this.$toast.error(err)
      })
    },
      downloadFile (url) {
          window.location = `http://172.30.0.9:5005/api/v1/file/download?fileName=${url}`
      },

    getSchoolCourseList (schoolId) {
      courseService.listBySchool(schoolId).then(res => {
        if (res) {
          courseService.listBySchool(schoolId, '', 0, res.totalElements).then(result => {
            this.courseList = result.content
          })
        }
      })
    }
  }
}
</script>

<style scoped>
th, td{
    vertical-align: middle;
    text-align: center!important;
    border: rgba(198, 203, 212, 0.58) solid 1px;
}
td{
    padding: 10px 16px !important;
}
</style>
